import React, { useCallback } from 'react';

import IconButton from '@mui/material/IconButton';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

interface EditCellProps {
  value: unknown;
  onClick: (value: unknown) => void;
  disabled?: boolean;
}

const EditCell: React.FC<EditCellProps> = ({ value, onClick, disabled = false }) => {
  const handleClick = useCallback(() => onClick(value), [onClick, value]);

  return (
    <IconButton aria-label="edit" color="primary" onClick={handleClick} disabled={disabled}>
      <EditOutlinedIcon />
    </IconButton>
  );
};

export default EditCell;
